(function () {
  'use strict';

  var input = document.querySelector('[data-nbr-faq-search]');
  if (!input) return;

  var clearBtn = document.querySelector('[data-nbr-faq-clear]');
  var status = document.querySelector('[data-nbr-faq-search-status]');
  var emptyState = document.querySelector('[data-nbr-faq-empty]');

  var categories = Array.prototype.map.call(
    document.querySelectorAll('[id^="shopify-section-"]'),
    function (section) {
      var rows = Array.prototype.map.call(section.querySelectorAll('.accordion'), function (row) {
        var titleEl = row.querySelector('.accordion__title');
        var contentEl = row.querySelector('.accordion__content');
        var question = titleEl ? titleEl.textContent.trim() : '';
        var answer = contentEl ? contentEl.textContent.replace(/\s+/g, ' ').trim() : '';
        return {
          el: row,
          details: row.querySelector('details'),
          wasOpen: row.querySelector('details') ? row.querySelector('details').open : false,
          question: question,
          answer: answer,
          text: (question + ' ' + answer).toLowerCase()
        };
      });
      return { section: section, rows: rows };
    }
  ).filter(function (c) {
    return c.rows.length > 0;
  });

  function injectFaqSchema() {
    if (document.querySelector('[data-nbr-faq-schema]')) return;
    var entities = [];
    categories.forEach(function (c) {
      c.rows.forEach(function (r) {
        if (!r.question || !r.answer) return;
        entities.push({
          '@type': 'Question',
          name: r.question,
          acceptedAnswer: { '@type': 'Answer', text: r.answer }
        });
      });
    });
    if (entities.length === 0) return;
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-nbr-faq-schema', '');
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });
    document.head.appendChild(script);
  }

  injectFaqSchema();

  // Native #anchor jumps land at a stale position on long pages where images/
  // fonts still shift layout after the browser's one-time fragment scroll.
  // Scrolling on click (after layout has settled) is more reliable.
  Array.prototype.forEach.call(document.querySelectorAll('[data-nbr-faq-pill]'), function (pill) {
    pill.addEventListener('click', function (event) {
      var targetId = pill.getAttribute('href');
      var target = targetId ? document.querySelector(targetId) : null;
      if (!target) return;
      event.preventDefault();
      history.pushState(null, '', targetId);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  function setStatus(message) {
    if (status) status.textContent = message;
  }

  function runSearch(rawQuery) {
    var query = (rawQuery || '').trim().toLowerCase();

    if (clearBtn) clearBtn.hidden = query === '';

    if (query === '') {
      categories.forEach(function (c) {
        c.section.classList.remove('nbr-faq-hidden');
        c.rows.forEach(function (r) {
          r.el.classList.remove('nbr-faq-hidden');
          if (r.details) r.details.open = r.wasOpen;
        });
      });
      if (emptyState) emptyState.hidden = true;
      setStatus('');
      return;
    }

    var totalMatches = 0;

    categories.forEach(function (c) {
      var categoryMatches = 0;
      c.rows.forEach(function (r) {
        var matches = r.text.indexOf(query) !== -1;
        r.el.classList.toggle('nbr-faq-hidden', !matches);
        if (matches) {
          categoryMatches++;
          if (r.details) r.details.open = true;
        }
      });
      c.section.classList.toggle('nbr-faq-hidden', categoryMatches === 0);
      totalMatches += categoryMatches;
    });

    if (emptyState) emptyState.hidden = totalMatches !== 0;
    setStatus(totalMatches === 0 ? 'No results found.' : totalMatches + ' result' + (totalMatches === 1 ? '' : 's') + ' found.');
  }

  var debounceId;
  input.addEventListener('input', function (event) {
    window.clearTimeout(debounceId);
    var value = event.target.value;
    debounceId = window.setTimeout(function () {
      runSearch(value);
    }, 120);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && input.value !== '') {
      event.preventDefault();
      input.value = '';
      runSearch('');
      input.focus();
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      runSearch('');
      input.focus();
    });
  }
})();
